import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import styles from "./Dropzone.module.css";
import UploadImage from "../../../src/Assets/Images/upload.png";
import { uploadFileToS3Campaign } from "../../Values/utils";
import { showSnackbarAction } from '../../Redux/actions';
import { useDispatch } from 'react-redux';

const DragAndDrop = ({
    setExcelUrl,
    setExcelTemplateHeader,
    // setBrowseContact,
    setCampType,
    user,
    setExcelTotalReciptent,
    setExcelFirstRow
    
}:{
    setExcelUrl:(name: string) => void,
    setExcelTemplateHeader:any,
    // setBrowseContact:any,
    setCampType:any,
    user:any,
    setExcelTotalReciptent?:any,
    setExcelFirstRow?:any
}) => {
    const [uploadStatus, setUploadStatus] = useState('');
    // const [uploadedFileUrl, setUploadedFileUrl] = useState('');
    const dispatcher = useDispatch();

    const handleFileUpload = async (file:any) => {
        try {
            // setUploadStatus('Uploading...');

            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = String(now.getFullYear()).slice(-2); // Get last two digits of the year
            const milliseconds = now.getTime(); // Get time in milliseconds
            const formattedTimestamp = `${day}/${month}/${year}-T-${milliseconds}`;
    
            const Id = `${user.uid}-${formattedTimestamp}`; // Combine user ID with formatted timestamp
            // const Id = user.uid+new Date(); // Replace this with the actual ID if needed
            const data = await uploadFileToS3Campaign(file, Id,"true");
            console.log("url for campaign Id",data)
            // if(data){
            //     setBrowseContact(true)
            // }
            if(data === 'Invalid file extension'){
            dispatcher(showSnackbarAction("Invalid file extension", "error"));
            return;
            }
            else{
                setCampType("Excel")
                setExcelUrl(data.url);
                setExcelTemplateHeader(data.headerData)
                setExcelTotalReciptent(data.count)
                setExcelFirstRow(data.firstRow)
            }
            
            // setUploadStatus('Upload successful!');
        } catch (error:any) {
            setUploadStatus('Upload failed. Please try again.');
        }
    };

    return (
        <Dropzone onDrop={acceptedFiles => {
            if (acceptedFiles.length > 0) {
                handleFileUpload(acceptedFiles[0]); // Only handle the first file
            }
        }}>
            {({ getRootProps, getInputProps }) => (
                <div className={styles.dragAndDropContainer}>
                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <p
                            className={styles.textStyle1}
                        >
                            Drag and drop contact XLS/CSV here</p>
                        <p className={styles.textStyle1}>or</p>
                        <p
                            className={styles.textStyle2}
                        >upload recipient contact</p>
                        <img className={styles.uploadImg} src={UploadImage} alt="file-upload" />
                    </div>
                </div>
            )}
        </Dropzone>
    )
}

export default DragAndDrop;
